<div class="condensed-short-header-wrapper">
  <div [ngClass]="!reportOptions.hideImages ? 'has-image' : 'hide-image'">
    <!-- TITLE AND SUBTITLE -->
    <div class="title-subtitle">
      <div class="title-subtitle__name" *ngIf="(titleGroup?.fields)[0] != null && templateFieldsCatalog">
        {{
          reportRecordData
            | reportFieldFormatter
              : {
                  templateFieldsCatalog: templateFieldsCatalog,
                  templateId: currentView.templateId,
                  field: (titleGroup?.fields)[0],
                  joinString: true,
                  onlyUrl: false,
                }
            | async
        }}
      </div>
      <ng-container *ngIf="(titleGroup?.fields)[1] != null">
        <ng-container
          *ngIf="
            templateProjectionMap != null && templateFieldsCatalog && titleGroup.fields[1].options?.hasAnchor;
            else subtitleValue
          "
          [ngTemplateOutlet]="templateProjectionMap | selectTemplateOutlet: 'miq-goes-to-record'"
          [ngTemplateOutletContext]="{
            classes: 'record-link',
            urlParams: reportRecordData | reportFieldRouteFn: openRecordUrlParams,
            content: subtitleValue,
          }"
        >
        </ng-container>
        <ng-template #subtitleValue>
          <div class="title-subtitle__address">
            {{
              reportRecordData
                | reportFieldFormatter
                  : {
                      templateFieldsCatalog: templateFieldsCatalog,
                      templateId: currentView.templateId,
                      field: (titleGroup?.fields)[1],
                      joinString: true,
                      onlyUrl: false,
                    }
                | async
            }}
          </div>
        </ng-template>
      </ng-container>
    </div>

    <div class="properties-component">
      <!-- ALL OTHER PROPS -->
      <ul *ngIf="attributesGroup && attributesGroup?.fields.length">
        <li
          *ngFor="let field of attributesGroup.fields"
          [class]="field.class ? field.class : ''"
          (click)="emitEditableFields($event, field.id)"
        >
          <ng-container *ngIf="!!field.label; else noLabel">
            <ng-container *ngIf="field | displayField: reportRecordData.data[0]">
              <label [ngClass]="{ clickable: editableFieldsService.editableTemplateAttributes[field.id] }">{{
                field.label
              }}</label>
              <span [ngClass]="{ clickable: editableFieldsService.editableTemplateAttributes[field.id] }">
                {{
                  reportRecordData
                    | reportFieldFormatter
                      : {
                          templateFieldsCatalog: templateFieldsCatalog,
                          templateId: currentView.templateId,
                          field: field,
                          joinString: true,
                          onlyUrl: false,
                        }
                    | async
                }}
              </span>
            </ng-container>
          </ng-container>

          <ng-template #noLabel>
            <label [ngClass]="{ clickable: editableFieldsService.editableTemplateAttributes[field.id] }">{{
              reportRecordData
                | reportFieldFormatter
                  : {
                      templateFieldsCatalog: templateFieldsCatalog,
                      templateId: currentView.templateId,
                      field: field,
                      joinString: true,
                      onlyUrl: false,
                    }
                | async
            }}</label>
          </ng-template>
        </li>
      </ul>
    </div>
  </div>
</div>
